import { render, staticRenderFns } from "./InverterPrintPage2.vue?vue&type=template&id=51f28293"
import script from "./InverterPrintPage2.vue?vue&type=script&lang=js"
export * from "./InverterPrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports